// Nota: ho spostato qui la funzione helper per evitare il warning di React Fast Refresh.
// Questo file non contiene componenti React, quindi può essere importato ovunque.

import { appConfig } from '../config/appConfig';

// Interfaccia per tipizzare i policyId (così evito errori sulle chiavi)
export interface PolicyIdMap {
  [key: string]: number;
}

/**
 * Restituisce il policyId corretto per la lingua passata.
 * Se non lo trova, fa fallback su 'it' o sul primo disponibile.
 *
 * Nota per il prossimo dev: se aggiungi nuove lingue,
 * basta aggiornare appConfig.integrations.iubenda.policyId.
 */
export const getPolicyIdForLang = (lng: string | undefined): number => {
  const policyIds = appConfig.integrations.iubenda.policyId as PolicyIdMap;

  // fallback: prima 'it', poi il primo disponibile, altrimenti 0
  const fallbackPolicyId = policyIds['it'] ?? Object.values(policyIds)[0] ?? 0;

  if (lng && policyIds[lng]) {
    return policyIds[lng];
  } else {
    if (lng) {
      console.warn(
        `Policy ID per lingua '${lng}' non trovato. Uso fallback ID: ${fallbackPolicyId}.`
      );
    }
    return fallbackPolicyId;
  }
};